import { render, staticRenderFns } from "./DeviceTypes.vue?vue&type=template&id=920c499a&scoped=true"
import script from "./DeviceTypes.vue?vue&type=script&lang=js"
export * from "./DeviceTypes.vue?vue&type=script&lang=js"
import style0 from "./DeviceTypes.vue?vue&type=style&index=0&id=920c499a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920c499a",
  null
  
)

export default component.exports